import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/workLocationActions';
// import {Actions as MYACTIONS} from '../../store/actions/myActions';
// import {Actions as TEAMACTIONS} from '../../store/actions/teamActions';
import ReactDOM from "react-dom";
// import axios from 'axios';
import Select from 'react-select';
import _ from 'lodash';
import DatePicker from "react-datepicker";
import { TimeInputFormat, DateInputFormat } from "../common/DateComponents";
import "react-datepicker/dist/react-datepicker.css";
import 'react-notifications/lib/notifications.css';
import * as yup from 'yup';
import { XMarkIcon, PhotoIcon } from '@heroicons/react/20/solid'
import Spinner from '../common/Spinner'
import { format, parse as parseDate, getDate, addHours, getDay, addDays, setHours, setMinutes, setSeconds, setMilliseconds, setDate, differenceInCalendarDays, differenceInMinutes, startOfWeek, differenceInCalendarISOWeeks, addYears} from 'date-fns';

let numSchema = yup.object().shape({
  hours: yup.number().min(0).max(24).nullable(true),
});


const WorkLocationBreakdown = ({
  from,
  to,
  onUpdate,
  data,
  savedHoursBreakdown
}) => {

  const days = [0, 1, 2, 3, 4, 5, 6]

  const firstDay = startOfWeek(from, { weekStartsOn: 1 })
  const lastWeekStartDate = startOfWeek(to, { weekStartsOn: 1 })

  const weeks = differenceInCalendarISOWeeks(lastWeekStartDate, firstDay)
  const weekNo = 0

  const fromDateString = format(from, "yyyy-MM-dd")
  const toDateString = format(to, "yyyy-MM-dd")

  console.log('weeks', weeks)

  const [errorText, setErrorText] = useState("");

  const handleChange = (value) => {
    if (isNaN(parseFloat(value.value)))
      value.value = null;
    numSchema.isValid({
      hours: value.value
    }).then(function (valid) {
      if (valid) {
        setErrorText("")
        onUpdate({
          value: value.value,
          date: value.date
        })
      } else {
        setErrorText("Cannot input values over 24 or under 0")
      }
    })
  }

  return (
    // for each week we need a row
    <div className="col-sm-12 leavedays" style={{textAlign:"center"}}>

      <table>
        <thead>
          <tr style={{ fontWeight: "bold" }}>
            <th style={{ textAlign: "left" }}>Weekday</th>
            <th>M</th>
            <th>T</th>
            <th>W</th>
            <th>T</th>
            <th>F</th>
            <th>S</th>
            <th>S</th>
          </tr>
        </thead>
        <tbody>
          {
            [...Array(weeks + 1)].map((a, weekNo) => (
              <React.Fragment key={weekNo}>
                <tr>
                  <th></th>
                  {
                    days.map(day => {
                      const dateToUse = addDays(firstDay, day + weekNo * 7)
                      const dayOfMonth = getDate(dateToUse);
                      const showMonth = dayOfMonth == 1 || (day == 0 && weekNo == 0)
                      return (
                        <th key={day} style={{ fontWeight: "bold", fontSize: 11, height: 16 }}>{showMonth ? format(dateToUse, 'MMM') : ''}</th>
                      )
                    })
                  }
                </tr>
                <tr>
                  <th style={{ textAlign: "left" }}>Day</th>
                  {
                    days.map(day => (
                      <th key={day}>{getDate(addDays(firstDay, day + weekNo * 7))}</th>
                    ))
                  }
                </tr>
                <tr>
                  <td style={{ textAlign: "left" }}>Hours</td>
                  {
                    days.map(day => {

                      const dateToUse = addDays(firstDay, day + weekNo * 7)
                      const dateToUseString = format(dateToUse, "yyyy-MM-dd")
                      const outOfRange = dateToUseString < fromDateString || dateToUseString > toDateString
                      const isPaid = savedHoursBreakdown && savedHoursBreakdown[dateToUseString] && savedHoursBreakdown[dateToUseString].isPaid

                      return (
                        <td key={day}>
                          <input
                            style={{
                              border: outOfRange ? "solid 1px #eceff1" : "solid 1px #ea611c",
                              width: "30px",
                              textAlign: "center",
                              background: outOfRange || isPaid ? "#eceff1" : 'inherit',
                            }}
                            value={data && data[dateToUseString] || ""}
                            disabled={outOfRange || isPaid}
                            onChange={(e) =>
                              handleChange({
                                value: e.target.value,
                                date: dateToUseString
                              })
                            }
                          />
                        </td>
                      )
                    })
                  }
                </tr>
              </React.Fragment>

            ))
          }

        </tbody>
      </table>
      <p style={{ textAlign: "left", color: "#ff5555" }} id="num-error">
        {errorText}
      </p>
    </div>
  )
}

const timeToHours = time => {

  const parts = time.split(':');

  const hours = parseInt(parts[0]) + (parseInt(parts[1]) / 60);

  return hours;
}

const firstDayOfThisMonth = setDate(new Date(), 1)

const WorkLocationModal = ({
  // employeeList,
  modalState,
  modalSaving,
  modalWorkLocation,
  savedHoursBreakdown,
  setOpenModal,
  saveWorkLocation,
  myAgreements,
  workLocationTypes,
  lockDate,
  workLocationSettingsByType,
  workLocationTypeOptions,
  currentDepartment,
  currentAgreement,
  workLocationStatusOptions,
  workLocationBalancesByType,
  getWorkLocation,
  clashingWorkLocation,
  uploadFile,
  uploading,
  uploaded,
  employeeOptions,
  getWorkLocationBreakdown,
  canEdit,
  // mySaveWorkLocation
}) => {

  const canEditHours = true;

  const today = new Date();
  const [workLocationType, setWorkLocationType] = useState(null);
  const [workLocationStatus, setWorkLocationStatus] = useState({ value: "Approved", label: "Approved" });
  const [employee, setEmployee] = useState();
  const [hours, setHoursWorked] = useState(8);
  const [hoursBreakdown, setHoursBreakdown] = useState({});
  const [comment, setComment] = useState();
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  // const [timeIn, setTimeIn] = useState(new Date(`${today.toISOString().substring(0,10)} 9:00`));
  // const [timeOut, setTimeOut] = useState(new Date(`${today.toISOString().substring(0,10)} 17:00`));
  const [timeIn, setTimeIn] = useState(setHours(setMinutes(setSeconds(setMilliseconds(today, 0),0),0),9));
  const [timeOut, setTimeOut] = useState(setHours(setMinutes(setSeconds(setMilliseconds(today, 0),0),0),17));
  const [errorText, setErrorText] = useState('')

  const [warningContent, setWarningContent] = useState(false);

  useEffect(() => {
    if(format(fromDate,'yyyy-MM-dd') == format(toDate,'yyyy-MM-dd')){
      if(hours > 24 || hours <= 0) 
        setErrorText("Hours requested cannot be under 0 or over 24!")
      else
        setErrorText('')
    } else {
      setErrorText('')
    }
  }, [hours])

  console.log('checkMe',fromDate,toDate,timeIn,timeOut)
  console.log('hoursBreakdown1111',hoursBreakdown)

  const agreementOptions = myAgreements && myAgreements.map(agreement => ({
    value: agreement.id,
    label: `${agreement.companyName}`
  }))

  let hoursAvailable;

  if (workLocationBalancesByType && employee && workLocationType && workLocationBalancesByType[workLocationType.value]) {
    const workLocationBalance = workLocationBalancesByType && employee && workLocationType && workLocationBalancesByType[workLocationType.value].find(
      item => employee.value == item.agreementId
    )

    hoursAvailable = workLocationBalance && workLocationBalance.balanceThisYearWithFutureWorkLocation && parseFloat(workLocationBalance.balanceThisYearWithFutureWorkLocation)
  }

  if (hoursAvailable && modalWorkLocation) {
    hoursAvailable += parseFloat(modalWorkLocation.hours)
  }

  const clashingWorkLocationList = clashingWorkLocation && clashingWorkLocation[employee && employee.value] || clashingWorkLocation
  console.log('clashingWorkLocationList', clashingWorkLocation, clashingWorkLocationList, employee && employee.value)

  const clashingWorkLocationExcludingThis = modalWorkLocation && clashingWorkLocationList && clashingWorkLocationList.filter(item => item.id != modalWorkLocation.id) || clashingWorkLocationList || []

  console.log('clashingWorkLocationExcludingThis', clashingWorkLocationExcludingThis)

  const alreadyHasWorkLocation = (clashingWorkLocationExcludingThis && employee && clashingWorkLocationExcludingThis.find(({ id, agreement }) => agreement == employee.value))

  const workLocationSettingsThisType = workLocationSettingsByType && workLocationSettingsByType.find(i => i.id == workLocationType.value)

  // has enough hours only applies as a lock on Work Location types where Balance Limit is not being checked
  const hasEnoughHours = !workLocationSettingsThisType || !workLocationSettingsThisType.applyIfBalanceAvailable || isNaN(hoursAvailable) || hours <= hoursAvailable
  console.log('alreadyHasWorkLocation', alreadyHasWorkLocation, clashingWorkLocationExcludingThis, clashingWorkLocation, clashingWorkLocationList, employee && employee.value)

  const hasRequired = employee && workLocationType?.value && fromDate && timeIn && timeOut

  useEffect(() => {
    if (employeeOptions && employeeOptions.length > 0) {
      setEmployee(employeeOptions[0])
    }
    setComment(null)
  }, [employeeOptions && employeeOptions.length])

  useEffect(() => {
    if (modalWorkLocation) {
      console.log('modalWorkLocation', modalWorkLocation)
      const selectedEmployee = employeeOptions && employeeOptions.find(item => item.value == modalWorkLocation.agreement)
      const selectedStatus = workLocationStatusOptions && workLocationStatusOptions.find(item => item.value == modalWorkLocation.status)
      const selectedWorkLocationType = workLocationTypeOptions && workLocationTypeOptions.find(item => item.value == modalWorkLocation.type)

      console.log('setEmployee', selectedEmployee, modalWorkLocation, modalWorkLocation.agreement)

      setEmployee(selectedEmployee)
      setWorkLocationStatus(selectedStatus)
      setWorkLocationType(selectedWorkLocationType)
      setFromDate(modalWorkLocation.date && new Date(modalWorkLocation.date))
      setToDate(new Date(modalWorkLocation.dateTo || modalWorkLocation.date))
      setHoursWorked(parseFloat(modalWorkLocation.hours).toFixed(2))
      setTimeIn(parseDate(`${modalWorkLocation.date} ${modalWorkLocation.startTime}`, modalWorkLocation.startTime.length == 5 ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd HH:mm:ss", new Date()))
      setTimeOut(parseDate(`${modalWorkLocation.date} ${modalWorkLocation.endTime}`, modalWorkLocation.endTime.length == 5 ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd HH:mm:ss", new Date()))
      setHoursBreakdown(savedHoursBreakdown || {})

      // then do something about this??
      if (modalWorkLocation.isParentEntry) {
        getWorkLocationBreakdown(modalWorkLocation.id)
      }

    } else {

      const applicableSalary = employee && employee.employee && employee.employee.salaries && employee.employee.salaries.find(item =>
        item.salaryEffectiveStart <= fromDate.toISOString() &&
        (
          item.salaryEffectiveStart == item.salaryEffectiveEnd ||
          fromDate.toISOString() <= item.salaryEffectiveEnd
        )
      )

      const noOfWeekdaysWorked = applicableSalary && applicableSalary.workingDays && applicableSalary.workingDays.length || 0

      const hoursPerShift = applicableSalary && applicableSalary.weeklyHours && noOfWeekdaysWorked && noOfWeekdaysWorked != 7 && parseFloat(applicableSalary.weeklyHours) / noOfWeekdaysWorked || 8;

      const newTimeIn = setHours(setMinutes(setSeconds(setMilliseconds(today, 0), 0), 0), 9)

      setFromDate(today)
      setToDate(today)
      setTimeIn(newTimeIn)
      setTimeOut(addHours(newTimeIn, hoursPerShift))
      setHoursWorked(hoursPerShift)
      setHoursBreakdown({})
    }
  }, [modalWorkLocation && modalWorkLocation.id, modalState]);

  useEffect(() => {
    if (savedHoursBreakdown) {
      console.log('update hourBreakdown from savedHours')
      const hourBreakdown = {}
      Object.keys(savedHoursBreakdown).map(d => hourBreakdown[d] = savedHoursBreakdown[d].hours)
      setHoursBreakdown(hourBreakdown)
    }
  }, [savedHoursBreakdown && JSON.stringify(savedHoursBreakdown)]);

  useEffect(() => {

    if (fromDate && toDate && modalState) {

      console.log('fromDate', fromDate, toDate)
      getWorkLocation({
        from: format(fromDate, 'yyyy-MM-dd'),
        to: format(toDate, 'yyyy-MM-dd'),
        status: ["Approved", "Pending"] // "Approved"// 
      })
    }

  }, [fromDate, toDate, modalState])

  if (!modalState || (!employeeOptions && !agreementOptions)) {
    return (<React.Fragment></React.Fragment>)
  }

  const saveWorkLocationData = () => {

    const dayDuration = differenceInCalendarDays(toDate, fromDate);

    if (dayDuration > 5 && !warningContent) {

      setWarningContent({
        title: "Warning: Work Location Exceeds 5 days",
        message: `Kindly note that this workLocation is for ${hours} hours over ${dayDuration} days.`
      })
      return;
    } else {
      if (warningContent) {
        setWarningContent(false)
      }
    }

    const workLocationData = {
      ...modalWorkLocation,
      workLocationType: workLocationType.value,
      agreement: employee.value,
      status: workLocationStatus.value,
      employee: employee.employee.employee_id,
      fromDate: `${format(fromDate, "yyyy-MM-dd")} ${format(timeIn, "HH:mm")}`,
      toDate: `${format(toDate, "yyyy-MM-dd")} ${format(timeOut, "HH:mm")}`,
      'hours': parseFloat(hours),
      hoursBreakdown,
      attachments: uploaded,
      comment: comment,
    }

    saveWorkLocation(workLocationData);

    const applicableSalary = employee && employee.employee && employee.employee.salaries && employee.employee.salaries.find(item =>
      item.salaryEffectiveStart <= fromDate.toISOString() &&
      (
        item.salaryEffectiveStart == item.salaryEffectiveEnd ||
        fromDate.toISOString() <= item.salaryEffectiveEnd
      )
    )

    const noOfWeekdaysWorked = applicableSalary && applicableSalary.workingDays && applicableSalary.workingDays.length || 0

    const hoursPerShift = applicableSalary && applicableSalary.weeklyHours && noOfWeekdaysWorked && noOfWeekdaysWorked != 7 && parseFloat(applicableSalary.weeklyHours) / noOfWeekdaysWorked || 8;

    const newTimeIn = setHours(setMinutes(setSeconds(setMilliseconds(today, 0), 0), 0), 9)

    setFromDate(today)
    setToDate(today)
    setTimeIn(newTimeIn)
    setTimeOut(addHours(newTimeIn, hoursPerShift))
    setHoursWorked(hoursPerShift)
    setHoursBreakdown({})
    setComment(null)
  }

  const calculateHours = (fromDate, toDate, timeIn, timeOut) => {

    const applicableSalary = employee && employee.employee && employee.employee.salaries && employee.employee.salaries.find(item =>
      item.salaryEffectiveStart <= fromDate.toISOString() &&
      (
        item.salaryEffectiveStart == item.salaryEffectiveEnd ||
        fromDate.toISOString() <= item.salaryEffectiveEnd
      )
    )

    console.log('calculateHoursfromDate', fromDate, toDate)

    const noOfWeekdaysWorked = applicableSalary && applicableSalary.workingDays && applicableSalary.workingDays.length || 0

    const hoursPerShift = applicableSalary && applicableSalary.weeklyHours && noOfWeekdaysWorked && noOfWeekdaysWorked != 7 && parseFloat(applicableSalary.weeklyHours) / noOfWeekdaysWorked || 8;

    const maxWeeklyHours = applicableSalary && applicableSalary.weeklyHours || 40

    console.log('calculateHours', calculateHours)

    let dayDifference = differenceInCalendarDays(toDate, fromDate);
    if (dayDifference > 0) {
      // add an extra day as last day does not count
      dayDifference += 1
    }
    console.log('dayDifference', dayDifference)

    let hours = 0
    let lastSevenDays = 0
    const hourBreakdown = {}


    if (dayDifference > 0) {

      // loop through each day of workLocation awarded.
      // if weekdays are set award as per weekdays otherwise award 8 / day until max limit reached
      [...Array(dayDifference)].map((a, dayNo) => {

        const dayToCheck = addDays(fromDate, dayNo)
        const weekdayToCheck = getDay(dayToCheck)

        const sevenDaysAgo = addDays(dayToCheck, -7)

        if (hourBreakdown[format(sevenDaysAgo, "yyyy-MM-dd")]) {
          lastSevenDays -= hourBreakdown[format(sevenDaysAgo, "yyyy-MM-dd")]
        }

        if (savedHoursBreakdown && savedHoursBreakdown[format(dayToCheck, "yyyy-MM-dd")]) {


          console.log('savedHoursBreakdownInUSE hourBreakdown', savedHoursBreakdown)
          hours += parseFloat(savedHoursBreakdown[format(dayToCheck, "yyyy-MM-dd")].hours || 0)
          hourBreakdown[format(dayToCheck, "yyyy-MM-dd")] = savedHoursBreakdown[format(dayToCheck, "yyyy-MM-dd")].hours || 0

          lastSevenDays += hourBreakdown[format(dayToCheck, "yyyy-MM-dd")]

        } else if (noOfWeekdaysWorked && noOfWeekdaysWorked != 7) {
          // check if employee works on this day

          // TODO update this on salary migration to get weekdays consistent as they are currently base 1 not 0
          const worksOnDay = applicableSalary && applicableSalary.workingDays && applicableSalary.workingDays.find(item => item.weekday - 1 == weekdayToCheck)

          if (worksOnDay) {
            hours += hoursPerShift
            hourBreakdown[format(dayToCheck, "yyyy-MM-dd")] = hoursPerShift
          }

        } else {

          // check if we already hit maximum per week else award hoursPerShift
          if (lastSevenDays < maxWeeklyHours) {

            lastSevenDays += hoursPerShift
            hours += hoursPerShift
            hourBreakdown[format(dayToCheck, "yyyy-MM-dd")] = hoursPerShift

          }
        }

      })

      // previous calculation without breakdown


      // const fullWeeks = Math.floor(dayDifference / 7)
      // const remainingDays = Math.floor(dayDifference % 7)
      // fullWeeks * 40 + Math.min(remainingDays * hoursPerShift,40) :
    } else {
      const timeDifference = differenceInMinutes(timeOut, timeIn);
      hours = Math.min(timeDifference / 60, hoursPerShift)
    }


    console.log('hourBreakdown', hourBreakdown);

      if(!isNaN(hours))
        setHoursWorked(hours.toFixed(2));
      else
        setHoursWorked(0)
        setErrorText('')

      setHoursBreakdown(hourBreakdown);

  }

  const isBeingCancelled = ["Cancelled", "Denied", "Deleted"].includes(workLocationStatus.value)

  // console.log('didyouupdate',date,timeIn,timeOut)
  const isPaid = modalWorkLocation && modalWorkLocation.isPaid || savedHoursBreakdown && _.find(savedHoursBreakdown,{isPaid: true})

  if (warningContent) {
    // show five day warning
    return (

      <div className="modal" tabindex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="block block-themed block-transparent remove-margin-b">
              <div className="block-header bg-primary-dark">
                <ul className="block-options">
                  <li>
                    <button type="button" onClick={() => { setWarningContent(false) }}>
                      <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                    </button>
                  </li>
                </ul>
                <h3 className="block-title">{warningContent.title}</h3>
              </div>
              <div className="block-content">

                <p>{warningContent.message}</p>

                <div className="block buttons">

                  <button className="btn btn-danger pull-left" onClick={() => { setWarningContent(false) }}>Cancel</button>
                  <button className="btn btn-success pull-right" onClick={() => saveWorkLocationData()} style={{ marginRight: 0 }}>Confirm</button>

                  <div className="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const handleWorkedHoursChange = (value) => {
    numSchema.isValid({ hours: value.replace("", 0) }).then(function (valid) {
      if(format(fromDate,'yyyy-MM-dd') == format(toDate,'yyyy-MM-dd')){
        if (valid) {
          setHoursWorked(value);
          setErrorText("");
        } else {
          setErrorText("Hours requested cannot be under 0 or over 24!");
        }
      } else {
        setErrorText('');
      }
    })
  };

  return (
    <div className="modal" tabindex="-1" role="dialog" aria-hidden="true" style={{display: "block",background: "rgba(0,0,0,0.4)",overflow:"auto"}}>
      <div className="modal-dialog" style={{marginTop: '10%'}}>
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b">
            <div className="block-header bg-primary-dark">
              <ul className="block-options">
                <li>
                  <button type="button" onClick={() => { setOpenModal(false, null) }}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">{modalWorkLocation ? "Edit" : "Add"} Work Location</h3>
            </div>
            <div className="block-content">
              <div className="form-group">
                {
                  employeeOptions &&
                  <div className="col-xs-6" style={{ paddingLeft: 0 }}>
                    <label htmlFor="material-text">Employee</label>
                    <Select
                      value={employee}
                      options={employeeOptions}
                      onChange={setEmployee}
                    />
                    <div className="clearfix"></div>
                  </div>
                }
                {
                  workLocationTypeOptions &&
                  <div className="col-xs-6" style={{ paddingLeft: 0 }}>
                    <label htmlFor="material-text">Location</label>
                    <Select
                      value={workLocationType}
                      options={workLocationTypeOptions}
                      onChange={setWorkLocationType}
                    />
                    <div className="clearfix"></div>
                  </div>
                }
                <div className="col-xs-6"></div>
                <div className="clearfix"></div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-md-8">
                  <div className="col-xs-6">
                    <label>From</label>
                      <DatePicker
                        selected={fromDate}
                        onChange={(newFromDate) => {
                          if(newFromDate) {
                            setFromDate(newFromDate)

                            console.log('newFromDate',newFromDate,toDate)
                            if (newFromDate > toDate){
                              setToDate(newFromDate)
                              calculateHours(newFromDate,newFromDate,timeIn,timeOut)
                            } else {
                              calculateHours(newFromDate,toDate,timeIn,timeOut)
                            }
                          }
                        }}
                        minDate={employee?.employee?.engagementDate && new Date(employee?.employee?.engagementDate)}
                        maxDate={(employee?.employee?.terminationDate && new Date(employee.employee.terminationDate)) || addYears(new Date(), 100)}
                        dateFormat="dd/MM/yyyy"
                        customInput={<DateInputFormat />}
                      />
                      {/*<input id="date" type="text" className="form-control remove_error" name="date"/>*/}
                    <div className="clearfix"></div>
                  </div>
                  <div className="col-xs-6">
                    <label htmlFor=" ">&nbsp;</label>
                    <DatePicker
                      selected={timeIn}
                      onChange={newTimeIn => {
                        calculateHours(fromDate, toDate, newTimeIn, timeOut)
                        setTimeIn(newTimeIn)
                      }}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      customInput={<TimeInputFormat />}
                    />
                    <div className="clearfix"></div>
                  </div>
                  <div className="clearfix"></div>

                  <div className="col-xs-6">
                    <label>To</label>
                      <DatePicker
                        selected={toDate}
                        onChange={(newToDate) => {
                          if (newToDate) {
                            calculateHours(fromDate,newToDate,timeIn,timeOut)
                            setToDate(newToDate)
                          }
                        }}
                        minDate={fromDate}
                        maxDate={(employee && new Date(employee?.employee?.terminationDate)) || addYears(new Date(), 1)}
                        dateFormat="dd/MM/yyyy"
                        customInput={<DateInputFormat />}
                      />
                      {/*<input id="date" type="text" className="form-control remove_error" name="date"/>*/}
                    <div className="clearfix"></div>
                  </div>
                  <div className="col-xs-6">
                    <label htmlFor=" ">&nbsp;</label>
                    <DatePicker
                      selected={timeOut}
                      onChange={newTimeOut => {
                        calculateHours(fromDate, toDate, timeIn, newTimeOut)
                        setTimeOut(newTimeOut)
                      }}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      customInput={<TimeInputFormat />}
                    />
                    <div className="clearfix"></div>
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div className="col-xs-12 col-md-4">
                  <div className="row">
                    {clashingWorkLocationExcludingThis && clashingWorkLocationExcludingThis.length > 0 &&
                      <div className="col-xs-6 col-md-12">
                        <label>Team Members on Work Location</label>
                        <ul>
                          {clashingWorkLocationExcludingThis.length >= 10 &&
                            <li>
                              {clashingWorkLocationExcludingThis.length} Team Members
                            </li>
                          }
                          {clashingWorkLocationExcludingThis.length < 10 && clashingWorkLocationExcludingThis.map(workLocation => (
                            <li>
                              {workLocation.employeeName} {workLocation.employeeSurame}
                            </li>
                          ))}
                        </ul>
                      </div>
                    }


                    <div className="col-xs-6 col-md-12">
                      <label>Attachments</label>
                      <ul style={{ listStyle: 'none' }}>
                        {uploading && uploading.length > 0 &&
                          uploading.map(fileName =>
                            <li>
                              <Spinner
                                style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                                className="animate-spin -ml-1 mr-3 h-5 w-5 "
                              />
                              <div style={{ float: 'left' }}>{fileName}</div>
                            </li>
                          )
                        }
                        {uploaded && uploaded.length > 0 &&
                          uploaded.map(file =>
                            <li>
                              <PhotoIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                              <div style={{ float: "left" }}>{file.name}</div>
                            </li>
                          )
                        }
                      </ul>
                      <label htmlFor="fileUpload" className="custom-file-upload btn btn-success">
                        <PhotoIcon style={{ height: "1.5em", verticalAlign: 'inherit', marginRight: 5 }} />
                        Upload Attachment
                      </label>
                      <input
                        style={{ display: 'none' }}
                        id="fileUpload"
                        type="file" accept='.pdf,.png,.jpg,.jpeg'
                        onChange={(e) => {
                          const file = e.target.files[0]; // accesing file
                          uploadFile(file, employee.value);
                        }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>

              <div className="form-group">
                <div className="col-sm-12">
                  <label>Comment</label>
                  <textarea
                    className="form-control"
                    type="text"
                    name="comment"
                    style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
                    onChange={(e) => {
                      setComment(e.target.value)
                    }}
                  >{comment}</textarea>
                  <div className="clearfix"></div>
                </div>
                <div className="clearfix"></div>
              </div>

              {format(fromDate, 'yyyy-MM-dd') != format(toDate, 'yyyy-MM-dd') &&
                <WorkLocationBreakdown
                  onUpdate={
                    ({
                      date,
                      value
                    }) => {

                      let newHours = parseFloat(hours)
                      const newBreakdown = { ...hoursBreakdown }

                      if (newBreakdown[date]) {
                        newHours -= newBreakdown[date] ? parseFloat(newBreakdown[date]) : 0
                      }

                      newBreakdown[date] = value
                      newHours += value ? parseFloat(value) : 0

                      console.log('newHours', newHours)

                      setHoursBreakdown(newBreakdown)
                      setHoursWorked(newHours.toFixed(2))
                    }
                  }
                  data={hoursBreakdown}
                  savedHoursBreakdown={savedHoursBreakdown}
                  from={fromDate}
                  to={toDate}
                />
              }

              <div className="form-group">
                <div className="col-sm-4">
                  <label>Hours Requested: {!canEditHours && hours}</label>
                  {
                    canEditHours &&
                    <input
                      className="form-control"
                      type="text"
                      name="hours"
                      disabled={format(fromDate, 'yyyy-MM-dd') != format(toDate, 'yyyy-MM-dd')}
                      onChange={(e) => {
                        if (!isNaN(e.target.value) || e.target.value == ""){
                          handleWorkedHoursChange(e.target.value)
                        }
                      }}
                      value={hours}
                    />
                  }
                  <div style={{fontSize:"11px"}}>
                    <span style={{color: "#ff5555"}}>{errorText}</span>
                    {
                      !isNaN(hoursAvailable) &&
                      <span>
                        <strong>{hoursAvailable.toFixed(2)}</strong> hours of Work Location Remaining
                      </span>
                    }
                  </div>
                  <div className="clearfix"></div>
                </div>

                {workLocationStatusOptions &&
                  <div className="col-sm-4">
                    <label htmlFor="material-text">Status</label>
                    <Select
                      value={workLocationStatus}
                      options={workLocationStatusOptions}
                      onChange={setWorkLocationStatus}
                    />
                    <div className="clearfix"></div>
                  </div>
                }
                <div className="clearfix"></div>
              </div>
              <div className="clearfix"></div>
              {/*<div className="form-group">
                <div className="col-sm-12" style={{paddingRight: 0, paddingLeft: 0}}>
                  <div className="form-material">
                    <label htmlFor=" ">Notes</label>
                    <textarea id="timesheets-note" name="note" className="form-control disabled edit" rows="1"></textarea>
                    <div className="clearfix"></div>
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div className="clearfix"></div>
              </div>*/}
              <div className="clearfix"></div>
              <div className="block buttons">
                {alreadyHasWorkLocation && !modalSaving && !isBeingCancelled &&
                  <button className="btn btn-danger pull-right" style={{ marginRight: 0 }}>{employee.label} already has a work location application</button>
                }
                { !hasRequired && !alreadyHasWorkLocation &&
                  <button className="btn btn-default pull-right" style={{marginRight: 0}}>Work Location Request Incomplete</button> 
                }
                { canEdit && !(modalWorkLocation) && hasRequired && hours && !modalSaving > 0 && !modalSaving && !alreadyHasWorkLocation &&
                  <button className="btn btn-success pull-right" onClick={() => saveWorkLocationData()} style={{marginRight: 0}}>Submit</button> 
                }
                { canEdit && modalWorkLocation && hasRequired && hours && !modalSaving > 0 && ((!alreadyHasWorkLocation) || isBeingCancelled) &&
                  <button className="btn btn-success pull-right" onClick={() => saveWorkLocationData()} style={{marginRight: 0}}>Update</button> 
                }
                {
                  modalSaving &&
                  <button className="btn btn-success pull-right" style={{ marginRight: 0 }}>
                    <Spinner
                      style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                      className="animate-spin -ml-1 mr-3 h-5 w-5 "
                    />
                    <div style={{ float: 'left' }}>Saving</div>
                  </button>
                }

                <div className="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {

  const currentAgreement = state.my.currentAgreement

  let workLocationTypes = state.workLocation.types;

  const lockDate = false;

  const employeeListWithSalary = state && state.employees && state.employees.employeeListWithSalary

  const workLocationTypeOptions = workLocationTypes && workLocationTypes.map(workLocationType => ({
    value: workLocationType.id,
    label: workLocationType.name
  }))

  const workLocationStatusOptions = [
    {
      value: "Approved",
      label: "Approved",
    },
    {
      value: "Pending",
      label: "Pending",
    },
    {
      value: "Cancelled",
      label: "Cancelled",
    },
    {
      value: "Denied",
      label: "Denied",
    },
    {
      value: "Deleted",
      label: "Deleted",
    },
    {
      value: "Pending Cancellation",
      label: "Pending Cancellation",
    }
  ]

  const employeeOptions = employeeListWithSalary && employeeListWithSalary.map(employee => ({
    value: employee.id,
    label: `${employee.employeeName} ${employee.employeeSurname}`,
    employee
  }))

  return {
    modalWorkLocation: state.workLocation.modalWorkLocation,
    savedHoursBreakdown: state.workLocation.modalWorkLocation && state.workLocation.modalWorkLocation.hoursBreakdown,
    modalState: state.workLocation.modalState,
    modalSaving: state.workLocation.modalSaving,
    workLocationBalancesByType: state.workLocation.workLocationBalancesByType,
    workLocationTypes,
    lockDate,
    workLocationSettingsByType: state.workLocation.workLocationSettings && state.workLocation.workLocationSettings.workLocationTypes,
    // withPermissions,
    workLocationTypeOptions,
    // modalWorkLocation,
    employeeOptions,
    // employeeList: employeeListWithSalary,
    workLocationStatusOptions,
    clashingWorkLocation: state.workLocation.clashingWorkLocation,
    updatingClashingWorkLocation: state.workLocation.clashingWorkLocationUpdating,
    uploading: state.workLocation.filesUploading,
    uploaded: state.workLocation.filesUploaded,
    canEdit: (state.permissions && state.permissions.my && state.permissions.my.workLocation) != "Read"

  }
}

const mapDispatchToProps = dispatch => ({
  setOpenModal: (status, timesheet) => dispatch(ACTIONS.setOpenModal(status, timesheet)),
  saveWorkLocation: (workLocation) => dispatch(ACTIONS.saveWorkLocation(workLocation)),
  getWorkLocation: (options) => dispatch(ACTIONS.workLocationGet(options, true)),
  getWorkLocationBreakdown: (id) => dispatch(ACTIONS.workLocationGetBreakdown(id)),
  uploadFile: (file, agreement) => dispatch(ACTIONS.uploadFile({ file, agreement })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkLocationModal) 
